import { apiRequest } from '../apiRequest';

export const hardDeleteLeadApi = async (leadId) => {
    return apiRequest(`/admin/lead/leads/${leadId}/hard-delete`, {
        method: 'DELETE',
        defaultErrorMessage: `Failed to hard delete lead #${leadId}`,
    });
};
